;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.quote.show')
    .controller('QuoteShowToolbarController', QuoteShowToolbarController)

  QuoteShowToolbarController.$inject = [
    // Angular
    '$scope', '$state', '$uibModal',
    // mananger
    'QuoteManager',
    // Services
    'UtilService', 'SnackService', 'DisplayService', 'TemplateService', 'PreferencesService',

    // Resolve
    'element', 'template', 'urls'

  ]

  function QuoteShowToolbarController (
    // Angular
    $scope, $state, $uibModal,
    // manager
    QuoteManager,
    // Services
    UtilService, SnackService, DisplayService, TemplateService, PreferencesService,

    // Resolve
    quote, template, urls

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        quote: quote,
        template: template,
        title: quote.title,
        status: quote.status,
        quoteManager: QuoteManager,
        number: getInvoiceNumber(),

        // Methods
        archiveQuote: archiveQuote,
        createPreFilledTemplate: createPreFilledTemplate,
        init: init,
        selectPreFilledTemplate: selectPreFilledTemplate,
        modifyPreFilledTemplateTitle: modifyPreFilledTemplateTitle,
        restoreQuote: restoreQuote,
        extranet: extranet,
        deleteQuote: deleteQuote
      })

      init()
    }

    $scope.$watch(function () {
      return template
    }, function () {
      self.template = template
      self.number = getInvoiceNumber()
    })

    function init () {
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
      })
    }

    function getInvoiceNumber () {
      if (quote.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat)
    }

    function archiveQuote () {
      var content = "Vous êtes sur le point d'archiver ce devis.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?"
      DisplayService.displayConfirm('Archiver', content).then(function () {
        quote.archive().then(function () {
          SnackService.snack({
            text: 'Devis archivé !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function createPreFilledTemplate (type, preFilledTemplate) {
      TemplateService.createPreFilledTemplate(type, preFilledTemplate).then((e) => {
        TemplateService.checkTemplatesTitles(type, e).then((allowCreation) => {
          if (allowCreation) {
            preFilledTemplate.modelTitle = e
            preFilledTemplate.isModel = true
            preFilledTemplate.linkedData = {
              solica: {
                interventions: []
              }
            }
            preFilledTemplate.save().then(() => {
              SnackService.snack({
                text: 'Modèle de devis pré-remplie enregistré !',
                delay: 5000
              })
            })
          }
        })
      })
    }

    function selectPreFilledTemplate (type) {
      TemplateService.selectPreFilledTemplate(type).then((config) => {
        $state.go('quote.new', config)
      })
    }

    function modifyPreFilledTemplateTitle (value) {
      let title = 'modifier le nom du modèle'
      return TemplateService.modifyPreFilledTemplateTitle(title, value).then((value) => {
        quote.modelTitle = value
        quote.save().then(() => {
          SnackService.snack({
            text: 'Nom du modèle modifié !',
            delay: 5000
          })
        })
      })
    }

    function restoreQuote () {
      var content = 'Vous êtes sur le point de restaurer ce devis.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        quote.restore().then(function () {
          SnackService.snack({
            text: 'Devis restauré !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function extranet () {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'quote' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        let url = `${urls.extranet}/quotes/${quote._id}`
        if (template !== false) {
          url += '/' + template._id
        }
        window.open(url, '_blank')
      })
    }

    function deleteQuote () {
      DisplayService.confirmDeletion().then(function () {
        self.quoteManager.delete(quote).then(() => {
          SnackService.snack({
            text: 'Devis supprimé !',
            delay: 5000
          })
          $state.go('quote.list')
        })
      })
    }
  }
})(window.angular, window._)
